export default "__VITE_ASSET__CuU6Tqku__"